import axios from 'axios';
import customerApi from '../../components/apis/customerApi';

export function loginApi(values) {
  return axios.create().post('/api/admin/auth', values);
}

export function adminOTPVerifyService(values) {
  return axios.create().post('/api/admin/auth/verify-code', values);
}

export function loginCustomer(values) {
  return customerApi
    .post('/api/customers/login', values)
    .then((res) => res.data);
}
export function getLoginFormOptions(values) {
  return axios
    .create()
    .get('/api/customers/form', values)
    .then((res) => res.data);
}

export function checkLoginApi(token) {
  return axios.create().get('/api/users/me', {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
}

export function sendPasswordRecoveryService(values, language) {
  return customerApi
    .post('/api/customers/send-recovery', values, {
      headers: { 'interface-language': language },
    })
    .then((res) => res.data);
}

export function submitPasswordRecoveryService(values) {
  return customerApi
    .post('/api/customers/submit-recovery', values)
    .then((res) => res.data);
}

export function serverConfigService() {
  return customerApi.get('/api/config/init').then((res) => res.data);
}
